import { render } from "./ChatAssistant.vue?vue&type=template&id=6f93ee5b&scoped=true"
import script from "./ChatAssistant.vue?vue&type=script&lang=js"
export * from "./ChatAssistant.vue?vue&type=script&lang=js"

import "./ChatAssistant.vue?vue&type=style&index=0&id=6f93ee5b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f93ee5b"]])

export default __exports__